import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Images,
  Newspaper,
  CalendarDays,
  Building2,
  Briefcase,
  FileText,
  Settings,
  ArrowRight
} from 'lucide-react';
import { api } from '../../lib/api';

const Stat = ({ icon: Icon, label, value, to }) => (
  <Link
    to={to}
    className="group flex items-center justify-between rounded-lg border border-[#E6DDC8] bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-[#C9A86A] hover:shadow-md"
  >
    <div className="flex items-center gap-4">
      <div className="flex h-11 w-11 items-center justify-center rounded-md bg-[#F6F2EA] text-[#C9A86A]">
        <Icon size={20} />
      </div>
      <div>
        <div className="text-[12px] uppercase tracking-wide text-[#0B2545]/55">
          {label}
        </div>
        <div className="font-serif text-2xl font-bold text-[#0B2545]">
          {value}
        </div>
      </div>
    </div>
    <ArrowRight size={16} className="text-[#C9A86A] transition-transform group-hover:translate-x-0.5" />
  </Link>
);

const AdminDashboard = () => {
  const [counts, setCounts] = useState({
    slides: 0,
    news: 0,
    events: 0,
    ministries: 0,
    investment: 0,
    documents: 0
  });

  useEffect(() => {
    (async () => {
      try {
        const [s, n, e, m, i, d] = await Promise.all([
          api.get('/slides'),
          api.get('/news'),
          api.get('/events'),
          api.get('/ministries'),
          api.get('/investment-sectors'),
          api.get('/documents')
        ]);
        setCounts({
          slides: s.data.length,
          news: n.data.length,
          events: e.data.length,
          ministries: m.data.length,
          investment: i.data.length,
          documents: d.data.length
        });
      } catch {
        /* ignore */
      }
    })();
  }, []);

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-serif text-3xl font-bold text-[#0B2545]">Dashboard</h1>
        <p className="mt-1 text-[13.5px] text-[#0B2545]/65">
          Manage every piece of content shown on the public website.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Stat icon={Images} label="Hero Slides" value={counts.slides} to="/admin/slides" />
        <Stat icon={Newspaper} label="News" value={counts.news} to="/admin/news" />
        <Stat icon={CalendarDays} label="Events" value={counts.events} to="/admin/events" />
        <Stat icon={Building2} label="Ministries" value={counts.ministries} to="/admin/ministries" />
        <Stat icon={Briefcase} label="Investment Sectors" value={counts.investment} to="/admin/investment" />
        <Stat icon={FileText} label="Documents" value={counts.documents} to="/admin/documents" />
        <Stat icon={Settings} label="Site Settings" value="Manage" to="/admin/settings" />
      </div>

      <div className="mt-10 rounded-lg border border-[#E6DDC8] bg-white p-6">
        <h2 className="font-serif text-lg font-bold text-[#0B2545]">
          Quick Tips
        </h2>
        <ul className="mt-3 list-inside list-disc space-y-1.5 text-[13.5px] text-[#0B2545]/75">
          <li>Use the <strong>Order</strong> field on Slides to control 1st, 2nd, 3rd, 4th position.</li>
          <li>Toggle a slide off with <strong>Active</strong> to hide it without deleting.</li>
          <li>All uploaded images are stored permanently on the server.</li>
          <li>Use <strong>Site Settings</strong> to update the President's message, contact info and social links.</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminDashboard;
